import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { useTheme } from '../context/ThemeContext';
import useWindowSize from '../hooks/useWindowSize';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import PersonIcon from '@mui/icons-material/Person';

function Success() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { colors } = useTheme();
  const { width } = useWindowSize();
  const isMobile = width < 768;

  if (!state) return (
    <div style={{ minHeight: '100vh', backgroundColor: colors.bg }}>
      <Navbar />
      <p style={{ color: colors.textSecondary, padding: '2rem' }}>No hay datos de compra</p>
    </div>
  );

  const { order, tickets, event } = state;

  return (
    <div style={{ minHeight: '100vh', backgroundColor: colors.bg }}>
      <Navbar />
      <div style={{ padding: isMobile ? '1rem' : '2rem', maxWidth: '800px', margin: '0 auto' }}>

        <div style={{ textAlign: 'center', padding: isMobile ? '1.5rem 0' : '2rem 0', marginBottom: '1.5rem' }}>
          <CheckCircleIcon style={{ color: '#00cc66', fontSize: isMobile ? '3rem' : '4rem', marginBottom: '0.8rem' }} />
          <h1 style={{ color: colors.text, fontSize: isMobile ? '1.5rem' : '2.2rem', fontWeight: 'bold', marginBottom: '0.5rem' }}>¡Compra completada!</h1>
          <p style={{ color: colors.textSecondary, fontSize: isMobile ? '0.85rem' : '1rem' }}>Tus entradas están listas. Guarda el QR de cada entrada.</p>
        </div>

        <div style={{ backgroundColor: colors.bgSecondary, borderRadius: '16px', border: `1px solid ${colors.border}`, padding: isMobile ? '1rem' : '1.5rem', marginBottom: '1.5rem' }}>
          <h2 style={{ color: colors.text, fontWeight: 'bold', marginBottom: '1rem', fontSize: '1rem' }}>Resumen del pedido</h2>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
            {event.image && (
              <img src={`http://localhost:3000${event.image}`} alt={event.name} style={{ width: isMobile ? '60px' : '80px', height: isMobile ? '60px' : '80px', objectFit: 'cover', borderRadius: '8px', border: `1px solid ${colors.border}`, flexShrink: 0 }} />
            )}
            <div>
              <h3 style={{ color: colors.text, fontWeight: 'bold', fontSize: isMobile ? '0.95rem' : '1.1rem', marginBottom: '0.3rem' }}>{event.name}</h3>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', marginBottom: '0.2rem' }}>
                <CalendarTodayIcon style={{ color: colors.accent, fontSize: 13 }} />
                <span style={{ color: colors.textSecondary, fontSize: '0.8rem' }}>{new Date(event.date).toLocaleDateString('es-ES', { day: 'numeric', month: 'long', year: 'numeric' })}</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
                <LocationOnIcon style={{ color: colors.accent, fontSize: 13 }} />
                <span style={{ color: colors.textSecondary, fontSize: '0.8rem' }}>{event.location}</span>
              </div>
            </div>
          </div>
          <div style={{ borderTop: `1px solid ${colors.border}`, paddingTop: '0.8rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <ConfirmationNumberIcon style={{ color: colors.accent, fontSize: 16 }} />
              <span style={{ color: colors.textSecondary, fontSize: '0.85rem' }}>{tickets.length} {tickets.length === 1 ? 'entrada' : 'entradas'}</span>
            </div>
            <span style={{ color: colors.accent, fontWeight: 'bold', fontSize: '1.2rem' }}>{parseFloat(order.total_price).toFixed(2)}€</span>
          </div>
        </div>

        <h2 style={{ color: colors.text, fontWeight: 'bold', marginBottom: '1rem', fontSize: '1rem' }}>Tus entradas</h2>
        {tickets.map((ticket, index) => (
          <div key={ticket.id} style={{ backgroundColor: colors.bgSecondary, borderRadius: '16px', border: `1px solid ${colors.border}`, padding: isMobile ? '1rem' : '1.5rem', marginBottom: '1rem', display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr auto', gap: '1rem', alignItems: 'center' }}>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.8rem' }}>
                <PersonIcon style={{ color: colors.accent, fontSize: 16 }} />
                <span style={{ color: colors.text, fontWeight: 'bold', fontSize: '0.9rem' }}>Entrada {index + 1}</span>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.5rem' }}>
                <div>
                  <p style={{ color: colors.textSecondary, fontSize: '0.72rem', marginBottom: '0.1rem' }}>Asistente</p>
                  <p style={{ color: colors.text, fontSize: '0.85rem', fontWeight: '500' }}>{ticket.attendee_name || '—'}</p>
                </div>
                <div>
                  <p style={{ color: colors.textSecondary, fontSize: '0.72rem', marginBottom: '0.1rem' }}>Email</p>
                  <p style={{ color: colors.text, fontSize: '0.85rem' }}>{ticket.attendee_email || '—'}</p>
                </div>
                <div>
                  <p style={{ color: colors.textSecondary, fontSize: '0.72rem', marginBottom: '0.1rem' }}>DNI / NIE</p>
                  <p style={{ color: colors.text, fontSize: '0.85rem' }}>{ticket.attendee_dni || '—'}</p>
                </div>
                <div>
                  <p style={{ color: colors.textSecondary, fontSize: '0.72rem', marginBottom: '0.1rem' }}>Fecha de nacimiento</p>
                  <p style={{ color: colors.text, fontSize: '0.85rem' }}>{ticket.attendee_birthdate ? new Date(ticket.attendee_birthdate).toLocaleDateString('es-ES') : '—'}</p>
                </div>
              </div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <img src={ticket.qr_code} alt="QR" style={{ width: isMobile ? '120px' : '140px', height: isMobile ? '120px' : '140px', borderRadius: '8px', border: `1px solid ${colors.border}` }} />
              <p style={{ color: colors.textSecondary, fontSize: '0.72rem', marginTop: '0.4rem' }}>Muestra este QR en la entrada</p>
            </div>
          </div>
        ))}

        <div style={{ display: 'flex', gap: '0.8rem', marginTop: '1.5rem', flexDirection: isMobile ? 'column' : 'row' }}>
          <button style={{ flex: 1, backgroundColor: 'transparent', border: `1px solid ${colors.border}`, color: colors.textSecondary, padding: '0.8rem', borderRadius: isMobile ? '4px' : '25px', cursor: 'pointer', fontWeight: 'bold', fontSize: '0.9rem' }} onClick={() => navigate('/my-tickets')}>
            Ver mis entradas
          </button>
          <button style={{ flex: 1, backgroundColor: colors.accent, color: colors.accentText, border: 'none', padding: '0.8rem', borderRadius: isMobile ? '4px' : '25px', cursor: 'pointer', fontWeight: 'bold', fontSize: '0.9rem' }} onClick={() => navigate('/')}>
            Volver al inicio
          </button>
        </div>
      </div>
    </div>
  );
}

export default Success;